import React, { Fragment } from 'react';
import parse from 'html-react-parser';

const TextComponent = ({ children }) => {

  return <Fragment>{parse(children)}</Fragment>
}
export default TextComponent;